// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
import BaseStore from '@core/stores/base';
import container from '@core/di';
import AssetVisitInfo, { AssetVisitInfoDTO } from '@shared/models/asset-visit-info';
import AssetVisitInfoService from '@shared/services/asset-visit-info';

@injectable()
export default class AssetVisitInfoStore extends BaseStore<AssetVisitInfoDTO, AssetVisitInfo, AssetVisitInfoService> {
  static diToken = Symbol('assetVisitInfo-store');

  // setup di token and clear the loading status.
  constructor() {
    super({ service: container.get<AssetVisitInfoService>(AssetVisitInfoService.diToken) });
    this.loading = {
      list: false,
    };
  }

  // Get a list of AssetVisitInfo by calling the service object.
  // If idList is given, return rows with matching ids.  Otherwise, return all rows.  
  getAssetVisitInfo = async (idList: Array<number>): Promise<Array<AssetVisitInfo> | undefined> => {
    //console.log("*** in store getAssetVisitInfo: ", idList.length);

    this.loading.list = true; // set loading status for the role.

    const items = await this.service.getAssetVisitInfo(idList);
    this.loading.list = false;  // clear loading status.
    
    return items;
  }

  // Send request to update a AssetVisitInfo row to portal-api.
  updateAssetVisitInfo = async (avDTO: Partial<AssetVisitInfoDTO>): Promise<boolean> => {
    console.log("*** in store updateVisit: ", avDTO);
    this.loading.list = true;

    const rc = await this.service.updateAssetVisitInfo(avDTO);
    this.loading.list = false;  // clear loading status.

    return rc;
  }

}